module.exports = __webpack_public_path__ + "static/media/example-1.c86015fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/MensHealthWA/example-1.jpg
// module id = 244
// module chunks = 0